<div class="vstack gap-3">
  <div *ngIf='paymentCalculation.discountAmount as discount'
       [innerHTML]="'campaign.payment.reserveParagraph0Coupon' | translate: {
                  amount: i18nFormatService.currency(discount),
                  budget: i18nFormatService.currency(campaignDraft.lineItemReview.lineItem.selfServiceBudget) }">
  </div>
  <ng-container *ngIf="getChargeAmount(paymentCalculation) as chargeAmount">
    <div *ngIf="chargeAmount.amount" [innerHTML]="'campaign.payment.reserveParagraph1' | translate: {
                amount: i18nFormatService.currency(chargeAmount) }"></div>
    <div *ngIf="chargeAmount.amount && paymentCalculation.taxRate" [innerHTML]="'campaign.payment.reserveParagraphTax' | translate: {
                amount: i18nFormatService.currency(chargeAmount), taxRate: paymentCalculation.taxRate, budget: i18nFormatService.currency(paymentCalculation.discountAmount || paymentCalculation.amount) }"></div>
    <div *ngIf="!chargeAmount.amount" [innerHTML]="'campaign.payment.reserveParagraph1Free' | translate"></div>
    <div *ngIf="chargeAmount.amount && !isCpc" [innerHTML]="'campaign.payment.reserveParagraph2' | translate: {
              imps: i18nFormatService.number(getBudgetedImpressions(), '1.0-0') }">
    </div>
    <div *ngIf="chargeAmount.amount && isCpc" [innerHTML]="'campaign.payment.reserveParagraph2Clicks' | translate: {
              clicks: i18nFormatService.number(getBudgetedClicks(), '1.0-0') }">
    </div>
    <div *ngIf="!isSubmittingDirect">
      <button [disabled]='isSubmittingDirect || campaignDraft.campaignForm.dirty' name='submit-and-review'
              type='button' class='btn btn-primary btnPayment' (click)='onSubmit()'>
        <i *ngIf="chargeAmount.amount && providerString === 'PAYPAL'" class='fab fa-paypal'></i>
        <i *ngIf="chargeAmount.amount && providerString !== 'PAYPAL'" class='fab fa-money'></i>
        <span *ngIf="chargeAmount.amount">{{ 'campaign.payment.' + providerString + '.reserveButton' | translate }}</span>
        <span *ngIf="!chargeAmount.amount">{{ 'campaign.payment.manual.reserveButton' | translate }}</span>
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="isSubmittingDirect">
    <ng-container *ngIf="submit$ | async"></ng-container>
    <ngb-alert type='primary' [dismissible]="false">
      <span>{{ 'campaign.payment.' + providerString + '.waitingForRedirect' | translate }}</span>
    </ngb-alert>
  </ng-container>
</div>
